import { TypographySM } from "@/components/typography/SM";
import { Share2 } from "lucide-react";
import { LinkReference } from "./LinkReference";
import { OnboardingStep } from "./OnboardingStep";

interface Props {
  isCompleted: boolean;
}

export function CreateSubscriptionOfferStep({ isCompleted }: Props) {
  return (
    <OnboardingStep
      title="Create a subscription offer for an external user"
      icon={<Share2 size={18} />}
      isCompleted={isCompleted}
    >
      <TypographySM className="mb-2 leading-6">
        Ready to share your work with the world? Send a subscription offer to a
        user outside your organization so they can start using your app!
      </TypographySM>

      <TypographySM className="leading-6">
        Once you have deployed an app of your own, go to the{" "}
        <LinkReference icon={Share2}>Subscriptions</LinkReference> page to send
        your first offer.
      </TypographySM>
    </OnboardingStep>
  );
}
